var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wsm",
    {
      class: [
        _vm.$root.isadmin && _vm.translationMode ? "wsmContainer" : "",
        _vm.active || _vm.openTranslator ? "activeElHoverWsm" : ""
      ]
    },
    [
      _c("VHTML", { attrs: { html: _vm.newText } }),
      _c("transition", { attrs: { name: "bounce" } }, [
        !_vm.loading && _vm.$root.isadmin && _vm.translationMode
          ? _c(
              "span",
              {
                ref: "transIcon",
                staticClass: "langBtn",
                class: [_vm.openTranslator ? "activeIcon" : ""],
                style: { left: _vm.howFarLeft },
                on: {
                  mouseover: function($event) {
                    _vm.active = true
                  },
                  click: function($event) {
                    _vm.openTranslator = !_vm.openTranslator
                    _vm.disableLink()
                  },
                  mouseleave: function($event) {
                    _vm.active = false
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 640 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                      }
                    })
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "bounce" } }, [
        _vm.openTranslator && _vm.$root.isadmin && _vm.translationMode
          ? _c("div", { class: ["translateWindow"] }, [
              _c(
                "span",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      _vm.openTranslator = !_vm.openTranslator
                    }
                  }
                },
                [_vm._v("X")]
              ),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newText,
                    expression: "newText"
                  }
                ],
                domProps: { value: _vm.newText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newText = $event.target.value
                  }
                }
              }),
              _c(
                "button",
                {
                  class: [_vm.error ? "error" : ""],
                  attrs: { disabled: _vm.done == true || _vm.error },
                  on: { click: _vm.submitTrans }
                },
                [_vm._v(_vm._s(_vm.error == false ? "Translate" : "error"))]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }